import { KEY_LOCALSTORAGE } from "../auth/core/_consts"

export const OBJECT_PERMISSIONS = {
  SUA_TON_KHO: "CIS.MODULE.WAREHOUSE.SUA_TON_KHO"
}

export const hasAuthority = (permission: string): boolean => {
  const authoritiesString = localStorage.getItem(KEY_LOCALSTORAGE.AUTHORITIES)
  const authorities = authoritiesString ? JSON.parse(authoritiesString) : {}
  return authorities[permission]
}
